module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Let Spin","short_name":"Let Spin","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"static/Let-Spin-Favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"76dbbfd0480ec0d54fa82cd845882026"},
    },{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"letspin","accessToken":"MC5YclhPU1JBQUFDTUFvc2pD.Ge-_vXQv77-9D--_vRzvv70q77-9Ou-_ve-_ve-_vSXvv71yPAZDZe-_vT9077-9PDjvv71vHu-_vQ"},
    },{
      plugin: require('../node_modules/@mobile-reality/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"environments":["production","development"]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
